/**
 * Deleting an activity changes derived data that other pages read from the Apollo cache:
 * check-in counts, shirt/ticket stock and `participant.lastActivity`.
 *
 * StatsPage and StockPage poll with `network-only`, so they self-heal. ParticipantPage
 * does neither — it would re-serve the stale ROOT_QUERY fields on its next mount.
 * `refetchQueries` cannot help because those queries are not active while the Activities
 * page is mounted, so evict the root fields instead and let them refetch on demand.
 *
 * Note: `participants` is now fetched through `useParticipants`, which reads with
 * `no-cache` and refetches on mount, so evicting that field is a no-op today. It is
 * kept in the list so the cache stays correct if anything reads the field again.
 */
const ACTIVITY_DERIVED_FIELDS = [
  'participants',
  'activitiesCount',
  'activitiesCountByTime',
  'activitiesCountByShirt',
  'activitiesCountByTicketType',
  'activitiesPagination',
]

export const invalidateActivityDerivedCaches = (client) => {
  if (!client || !client.cache) return
  const { cache } = client
  ACTIVITY_DERIVED_FIELDS.forEach((fieldName) => {
    cache.evict({ id: 'ROOT_QUERY', fieldName })
  })
  cache.gc()
}

export default invalidateActivityDerivedCaches
